exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container[data-v-43c2c356] {\n  width: 100%;\n}\n.dayTime-container[data-v-43c2c356] {\n  display: inline-block;\n  border-bottom: 1px solid #ddd;\n  margin-right: 10px;\n  width: calc((100% - 30px) / 2);\n}\n.dayTime-container .distance-element[data-v-43c2c356] {\n    width: 100%;\n}\n.dayTime-container[data-v-43c2c356]:last-child {\n  margin-right: 0;\n}\n", ""]);

// exports
